
const sizes = {
  full: '',
  default: 'max-w-1500 px-6',
  small: 'max-w-3xl px-3'
}
const spaceBefore = {
  none: '',
  large: 'pt-24',
  default: 'pt-12'
}

export default {
  name: 'DashboardPageWrapper',

  props: {
    size: {
      type: String,
      default: 'default',
      validator: (value) => {
        return ['large', 'default', 'small'].includes(value)
      }
    },
    spaceBefore: {
      type: String,
      default: 'default',
      validator: (value) => {
        return ['large', 'default'].includes(value)
      }
    }
  },

  computed: {
    sizeClasses () {
      return sizes[this.size]
    },
    spaceBeforeClasses () {
      return spaceBefore[this.spaceBefore]
    }
  }
}
